<modal-panel title="Split Rate" (close)="closeDialog()" data-testid="split-rate-modal-panel">
    <ng-container data-testid="split-rate-modal-container">
      <split-rate-info [data]="data.agentId"></split-rate-info>
    </ng-container>
    <ng-container modalPanelFooter data-testid="split-rate-modal-footer">
      <button mat-raised-button color="primary" (click)="closeDialog()" data-testid="split-rate-modal-close-button">Close</button>
    </ng-container>
</modal-panel>
  